module.exports = __webpack_public_path__ + "img/stbd.11af9b33.png";